// src/pages/Home/Home.js
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';
import './Home.css';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);

  return (
    <div className="home-page">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>UBR Engineering Works | Home</title>
        <meta
          name="description"
          content="UBR Engineering Works is a leading manufacturer of wire and cable machinery equipment, delivering top-quality solutions to the cable industry for decades."
        />
        <meta
          name="keywords"
          content="UBR Engineering, wire cable machines, cable manufacturing, industrial machinery, Bhiwadi, Rajasthan, India"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <section id="home" className="hero-section">
        <div
          className="hero-background"
          style={{
            backgroundImage: "url('/images/image.png')"
          }}
        >
          <motion.h1
            className="carousel-title"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Welcome to UBR Engineering Works
          </motion.h1>

          <motion.h2
            className="carousel-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.3 }}
          >
            Wire & Cable Machine Manufacturing
          </motion.h2>

          <motion.p
            className="carousel-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.4, delay: 0.6 }}
          >
            Leading manufacturer of cable machinery equipment with over decades of expertise in delivering high-quality solutions for the cable industry.
          </motion.p>
        </div>
      </section>
    </div>
  );
};

export default Home;
